import type { ReactElement } from 'react';
import { Dialog } from '../../components/Dialog.js';
import type { MetricEntry } from '../../api/metricsTypes.js';

export interface ConfirmDeleteDialogProps {
  open: boolean;
  target: MetricEntry | null;
  busy: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function ConfirmDeleteDialog({
  open,
  target,
  busy,
  onCancel,
  onConfirm,
}: ConfirmDeleteDialogProps): ReactElement {
  return (
    <Dialog open={open} onClose={onCancel} title="Delete this measurement?">
      <div
        className="flex flex-col gap-3 text-sm"
        data-testid="confirm-delete-dialog"
      >
        <p style={{ color: 'var(--text-main)' }}>
          Are you sure you want to delete this measurement?
        </p>
        {target ? (
          <p
            className="rounded-md border px-3 py-2 text-xs"
            style={{
              borderColor: 'var(--border)',
              color: 'var(--text-muted)',
            }}
            data-testid="confirm-delete-summary"
          >
            {target.measured_at} · {target.weight_kg.toFixed(1)} kg
          </p>
        ) : null}
        <div className="mt-2 flex justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            disabled={busy}
            className="rounded-md border px-4 py-2 text-sm"
            style={{
              background: 'transparent',
              borderColor: 'var(--border)',
              color: 'var(--text-main)',
              minHeight: 48,
            }}
            data-testid="confirm-delete-cancel"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={busy}
            className="rounded-md px-4 py-2 text-sm font-medium"
            style={{
              background: '#dc2626',
              color: '#ffffff',
              minHeight: 48,
              opacity: busy ? 0.7 : 1,
            }}
            data-testid="confirm-delete-confirm"
          >
            {busy ? 'Deleting…' : 'Delete'}
          </button>
        </div>
      </div>
    </Dialog>
  );
}
